import { render, staticRenderFns } from "./successfulCaseBom.vue?vue&type=template&id=efcdb906&scoped=true&"
import script from "./successfulCaseBom.vue?vue&type=script&lang=js&"
export * from "./successfulCaseBom.vue?vue&type=script&lang=js&"
import style0 from "./successfulCaseBom.vue?vue&type=style&index=0&id=efcdb906&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcdb906",
  null
  
)

export default component.exports